<script setup>

import AuthLayout from "../components/view-components/AuthLayout.vue";
import Button from "primevue/button";
import {router, usePage} from "@inertiajs/vue3";

const goToThirdParty = () => {
    document.location.href = usePage().props.url;
}
</script>

<template>
    <AuthLayout>
        <h1 class="text-2xl mb-2">
            Pozor
        </h1>
        <p class="text-sm mb-4 text-justify text-neutral-500">
            Pro správné fungování Roori potřebujeme všechna povolení, o která Vás požádal přihlašovací dialog. Prosím, přihlaste se znovu a udělte všechna potřebná oprávnění.
        </p>
        <h4 class="text-lg mb-2">Proč potřebujeme tato povolení?</h4>
        <p class="text-sm mb-4 text-justify text-neutral-500">
            Oprávnění, která žádáme, jsou nezbytná pro zajištění plné funkčnosti naší aplikace. Vaše data jsou využívána pouze pro účely, které zajišťují funkce Roori, a nikdy je neukládáme ani nesdílíme s třetími stranami. Díky těmto oprávněním můžeme zajistit, že všechny funkce aplikace budou fungovat správně.
        </p>
        <Button label="Přejít na přihlašovací stránku dodavatele" icon="pi pi-user" @click="goToThirdParty" class="w-full"></Button>
    </AuthLayout>
</template>

<style scoped lang="scss">

</style>
